/* unplugin-vue-components disabled */import script from "./VabSubMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./VabSubMenu.vue?vue&type=script&lang=ts&setup=true"
/* custom blocks */
import block0 from "./VabSubMenu.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__